/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Tone_InfoInputs */

const cs_toast_tone_info = /** @type {(inputs: Toast_Tone_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informace`)
};

const en_toast_tone_info = /** @type {(inputs: Toast_Tone_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Info`)
};

/**
* | output |
* | --- |
* | "Info" |
*
* @param {Toast_Tone_InfoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const toast_tone_info = /** @type {((inputs?: Toast_Tone_InfoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Tone_InfoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toast_tone_info(inputs)
	return cs_toast_tone_info(inputs)
});